import * as z from "zod"

export const FrontEmailModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  front_id: z.string(),
  front_uid: z.string(),
  subject: z.string(),
  conversation_id: z.string(),
})
